module.exports = __webpack_public_path__ + "static/img/200282.969c3b01.png";